"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    var _require$projectName, _require;
    return {
      projectName: (_require$projectName = (_require = require('@/settings')) === null || _require === void 0 ? void 0 : _require.projectName) !== null && _require$projectName !== void 0 ? _require$projectName : ''
    };
  }
};